import { ActionType, createReducer } from 'typesafe-actions';
import { resetDrawResultToStoreAction, saveDrawResultToStoreAction } from './actions';
import { IDrawResultState } from './types';

export const defaultDrawResultState: IDrawResultState = {
  cards: {},
  points: {
    player: 0,
    banker: 0,
  },
};

const actions = {
  saveDrawResultToStoreAction,
  resetDrawResultToStoreAction,
};

export const drawResultReducer = createReducer<IDrawResultState, ActionType<typeof actions>>(
  defaultDrawResultState,
)
  .handleAction(saveDrawResultToStoreAction, (state, { payload: { cards, points } }) => ({
    ...state,
    cards,
    points,
  }))
  .handleAction(resetDrawResultToStoreAction, (state) => ({
    ...defaultDrawResultState,
  }));
